import React, { useEffect, useState } from "react";
import { useAsyncAxios, utilAxiosWithAppToken } from "../../utils/customAxios";
import { BrowserView, MobileView } from "react-device-detect";
import { Accordion } from "react-bootstrap";

import * as Request from "../../commons/request";
import * as TypeDTO from "../../commons/typeDTO";

const Faq = ({
    isB2b,
    carType,
    isAccordion,
    className,
    faqIds,
}: {
    isB2b?: boolean;
    carType?: string;
    isAccordion?: boolean;
    className?: string;
    faqIds?: number[];
}) => {
    const dieselType = "디젤(3인승)";
    const [faqs, setFaqs] = useState<Array<TypeDTO.RentFaqDto>>();

    useEffect(() => {
        requestGetFaqs();
    }, []);

    const requestAxiosGetFaqs = async () => {
        const response = await utilAxiosWithAppToken().get(Request.RENT_FAQS_URL);
        return response.data;
    };

    const { error: errorGetFaqs, data: resultGetFaqs, execute: requestGetFaqs } = useAsyncAxios(requestAxiosGetFaqs);

    useEffect(() => {
        if (!resultGetFaqs) return;

        setFaqs(resultGetFaqs.rentFaqs);
    }, [resultGetFaqs]);

    useEffect(() => {
        if (!errorGetFaqs) return;

        console.log("errorGetFaqs", errorGetFaqs);
    }, [errorGetFaqs]);

    const faqsB2bType = [
        {
            rentFaqId: 1,
            faqQuestion: "반려동물과 함께 이용할 수 있나요?",
            faqAnswer: "반려동물 동반 이용을 엄격히 제한합니다.(쾌적한 환경 유지 및 알레르기 예방 차원)",
        },
        {
            rentFaqId: 2,
            faqQuestion: "물품을 파손/분실/훼손 했어요.",
            faqAnswer: "물품 파손/분실/훼손 시에는 별도 비용이 청구될 수 있습니다.",
        },
        {
            rentFaqId: 3,
            faqQuestion:
                carType === dieselType ? "차량 연료 및 톨게이트 비용은 어떻게 처리하나요?" : "배터리 충전 및 톨게이트 비용은 어떻게 처리하나요?",
            faqAnswer:
                carType === dieselType
                    ? "연료(경유)는 FULL 충전 후 반납해 주세요. 고속도로 통행료 미납 시 사후 예약자에게 청구 됩니다."
                    : "배터리는 90% 이상 충전 후 반납해 주세요. 고속도로 통행료 미납 시 사후 예약자에게 청구 됩니다.",
        },
        {
            rentFaqId: 4,
            faqQuestion: "차량 법규를 위반하면 어떻게 되나요?",
            faqAnswer: "각종 차량법규 위반에 따른 범칙금 및 과태료는 운전자에게 부과됩니다.",
        },
    ];

    return (
        <>
            <MobileView>
                {isAccordion ? (
                    <Accordion alwaysOpen defaultActiveKey={["0"]} className="support mobileFaqAccordion">
                        {faqs &&
                            faqs.map((faq: TypeDTO.RentFaqDto, index) => (
                                <Accordion.Item key={faq.rentFaqId} eventKey={index.toString()} className="accordion-item">
                                    <Accordion.Header style={{ marginTop: "0" }}>{faq.faqQuestion}</Accordion.Header>
                                    <Accordion.Body>
                                        <ul style={{ paddingLeft: 20 }}>
                                            {faq.faqAnswer.split("\n").map((line, index) => (
                                                <li
                                                    style={{ whiteSpace: "pre-wrap" }}
                                                    key={index}
                                                    dangerouslySetInnerHTML={{
                                                        __html: line.replace(". -", `.\n -`),
                                                    }}
                                                />
                                            ))}
                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                    </Accordion>
                ) : (
                    <div className={className}>
                        {isB2b
                            ? faqsB2bType.map(
                                  (faq, index) =>
                                      (!faqIds || faqIds.includes(faq.rentFaqId)) && (
                                          <div key={faq.rentFaqId}>
                                              <p className="text-bold">{faq.faqQuestion}</p>
                                              {faq.faqAnswer.split("\n").map((line, index) => (
                                                  <p
                                                      key={index}
                                                      dangerouslySetInnerHTML={{
                                                          __html: line.replace(". -", `.\n -`),
                                                      }}
                                                  />
                                              ))}
                                              {index + 1 < faqsB2bType.length && (
                                                  <hr style={{ height: "1px", background: "#1C304A85", transform: "scaleY(0.4)", margin: "8px 0" }} />
                                              )}
                                          </div>
                                      )
                              )
                            : faqs?.map(
                                  (faq: TypeDTO.RentFaqDto, index) =>
                                      (!faqIds || faqIds.includes(faq.rentFaqId)) && (
                                          <div key={faq.rentFaqId}>
                                              <p className="text-bold">{faq.faqQuestion}</p>
                                              {faq.faqAnswer.split("\n").map((line, index) => (
                                                  <p
                                                      key={index}
                                                      dangerouslySetInnerHTML={{
                                                          __html: line.replace(". -", `.\n -`),
                                                      }}
                                                  />
                                              ))}
                                              {index + 1 < faqs.length && (
                                                  <hr style={{ height: "1px", background: "#1C304A85", transform: "scaleY(0.4)", margin: "8px 0" }} />
                                              )}
                                          </div>
                                      )
                              )}
                    </div>
                )}
            </MobileView>
            <BrowserView>
                {isAccordion ? (
                    <Accordion alwaysOpen defaultActiveKey={["0"]} className="support">
                        {faqs &&
                            faqs.map((faq: TypeDTO.RentFaqDto, index) => (
                                <Accordion.Item
                                    style={{ marginBottom: "1.5rem" }}
                                    key={faq.rentFaqId}
                                    eventKey={index.toString()}
                                    className="accordion-item"
                                >
                                    <Accordion.Header style={{ marginTop: "0" }}>{faq.faqQuestion}</Accordion.Header>
                                    <Accordion.Body>
                                        <ul>
                                            {faq.faqAnswer.split("\n").map((line, index) => (
                                                <li
                                                    style={{ whiteSpace: "pre-wrap" }}
                                                    key={index}
                                                    dangerouslySetInnerHTML={{
                                                        __html: line.replace(". -", `.\n -`),
                                                    }}
                                                />
                                            ))}
                                        </ul>
                                    </Accordion.Body>
                                </Accordion.Item>
                            ))}
                    </Accordion>
                ) : (
                    <div className={`${className}`}>
                        {isB2b
                            ? faqsB2bType.map(
                                  (faq, index) =>
                                      (!faqIds || faqIds.includes(faq.rentFaqId)) && (
                                          <div key={faq.rentFaqId}>
                                              <p className="text-bold">{faq.faqQuestion}</p>
                                              {faq.faqAnswer.split("\n").map((line, index) => (
                                                  <p
                                                      key={index}
                                                      dangerouslySetInnerHTML={{
                                                          __html: line.replace(". -", `.\n -`),
                                                      }}
                                                  />
                                              ))}
                                              {index + 1 < faqsB2bType.length && (
                                                  <hr style={{ height: "1px", background: "#1C304A85", transform: "scaleY(0.4)", margin: "8px 0" }} />
                                              )}
                                          </div>
                                      )
                              )
                            : faqs?.map(
                                  (faq: TypeDTO.RentFaqDto, index) =>
                                      (!faqIds || faqIds.includes(faq.rentFaqId)) && (
                                          <div key={faq.rentFaqId}>
                                              <p className="text-bold">{faq.faqQuestion}</p>
                                              {faq.faqAnswer.split("\n").map((line, index) => (
                                                  <p
                                                      key={index}
                                                      dangerouslySetInnerHTML={{
                                                          __html: line.replace(". -", `.\n -`),
                                                      }}
                                                  />
                                              ))}
                                              {index + 1 < faqs.length && (
                                                  <hr style={{ height: "1px", background: "#1C304A85", transform: "scaleY(0.4)", margin: "8px 0" }} />
                                              )}
                                          </div>
                                      )
                              )}
                    </div>
                )}
            </BrowserView>
        </>
    );
};

export default Faq;
